import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const Cancel = () => (
  <div data-testid="cancel-page" className="pt-32 pb-24 min-h-screen bg-cream flex items-center justify-center px-5">
    <div className="max-w-md w-full text-center">
      <div className="w-20 h-20 mx-auto rounded-full bg-blush flex items-center justify-center">
        <XCircle size={40} className="text-terracotta" strokeWidth={1.5} />
      </div>
      <h1 className="mt-8 font-serif text-3xl sm:text-4xl font-light text-onyx">Paiement annulé</h1>
      <p className="mt-4 text-sm text-muted-warm leading-relaxed">
        Aucun montant n'a été débité. Votre panier est conservé — reprenez là où vous vous étiez arrêtée.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <Link
          to="/checkout"
          data-testid="cancel-retry-button"
          className="rounded-full bg-terracotta text-cream px-6 py-3.5 text-sm font-semibold hover:bg-onyx transition-colors"
        >
          Réessayer le paiement
        </Link>
        <Link
          to="/"
          data-testid="cancel-home-button"
          className="rounded-full border border-blush-deep bg-white px-6 py-3.5 text-sm font-medium text-onyx hover:border-rose-gold transition-colors"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  </div>
);

export default Cancel;
